import { supabase } from "@/lib/supabase"

export const SIGNED_URL_EXPIRY = 60 * 60

export const extractStoragePath = (pathOrUrl: string) => {
  if (!pathOrUrl) {
    return ""
  }
  const marker = "/object/public/application-documents/"
  const idx = pathOrUrl.indexOf(marker)
  if (idx !== -1) {
    return pathOrUrl.substring(idx + marker.length)
  }
  return pathOrUrl
}

export const createSignedDocumentUrl = async (pathOrUrl: string): Promise<string | null> => {
  if (!pathOrUrl) {
    return null
  }
  const path = extractStoragePath(pathOrUrl)
  const { data, error } = await supabase.storage
    .from("application-documents")
    .createSignedUrl(path, SIGNED_URL_EXPIRY)
  if (error) {
    console.error("Error creating signed URL:", error)
    return null
  }
  return data.signedUrl
}
